import { render, staticRenderFns } from "./customPlayer.vue?vue&type=template&id=61f3f230&scoped=true"
import script from "./customPlayer.vue?vue&type=script&lang=js"
export * from "./customPlayer.vue?vue&type=script&lang=js"
import style0 from "./customPlayer.vue?vue&type=style&index=0&id=61f3f230&prod&lang=scss&scoped=true"
import style1 from "./customPlayer.vue?vue&type=style&index=1&id=61f3f230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3f230",
  null
  
)

export default component.exports